module.exports = __webpack_public_path__ + "img/heart_shapes.d051ee99.jpg";